import * as log from "loglevel";
import {times, head, last, forEach, find, filter, tail, without, difference} from 'lodash';
import {game} from '../../GameCore';
import {gameConfig} from '../../config/GameConfig';
import {levelGroup} from '../Level';
import {gameState} from '../../config/GameState';
import {slowToStandstill, showSign} from '../../sprites/player/Player';
import {stopStageTimer} from '../stages/StageManager';
import {stopCountdownTimer} from '../../timer/GameTimer';
import {showSecondaryScreen} from '../../../screens/ScreenManager';
import {queuePowerUp} from '../power-ups/PowerUps';
import {resetObstacles, restartObstacles} from '../ground/Obstacles';
import {allowPlatforms} from '../platforms/Platforms';
import {playSound} from '../../audio/AudioManager';

export var backgroundSprites: Phaser.Sprite[];
export var outsideSprites: Phaser.Sprite[];

var offsetX: number,
    tileCount: number,
    outsideTile: Phaser.Sprite,
    insideTile: Phaser.Sprite;

/**
 * create the floor for the game
 */
export function createBackground()
{
    //  reset the background before we begin

    resetBackground();

    //  create all the tiles we need

    coverBackgroundWithTiles(6);
}


/**
 * create enough background tile sprites to cover the screen
 * @param tiles_needed
 */
function coverBackgroundWithTiles(tiles_needed: number)
{
    var sprite: Phaser.Sprite;

    backgroundSprites = times(tiles_needed, (i: number) =>
    {
        //  create a sprite

        sprite = game.add.sprite((gameConfig.bgTileWidth - 1) * i, 0, getTileSetName(), getFrameName());

        //log.debug(getTileSetName(), getFrameName())

        //sprite.frameName =

        levelGroup.addChild(sprite);

        incrementTileCount();

        sprite['spriteID'] = 'inside-' + i;


        //  return the sprite

        return sprite;
    });

    outsideSprites = times(5, (i: number) =>
    {
        //  create a sprite

        sprite = game.add.sprite(0, 2500, 'bg-outside');

        levelGroup.addChild(sprite);

        sprite['spriteID'] = 'outside-' + i;

        //  return the sprite

        return sprite;
    });
}


/**
 * get the ID of the current tileset
 * @returns {any}
 */
export function getTileSetId()
{
    //log.debug(currentStage, gameConfig.level.stages)

    if (gameState.level.isOutside) return 'outside';

    return gameConfig.level.stages[gameState.level.currentStage % 4];
}


/**
 * get the name of the current tile set
 * @returns {string}
 */
function getTileSetName()
{
    return 'bg-' + getTileSetId();
}


/**
 * get the frame name for the next frame
 * @returns {string}
 */
function getFrameName()
{
    return getTileSetId() + '-' + tileCount;
}


/**
 * increment the tile count
 */
function incrementTileCount()
{
    tileCount ++;

    if (tileCount === 3) tileCount = 0;
}


/**
 * reset the background
 */
export function resetBackground()
{
    offsetX = 0;
    tileCount = 0;

    forEach(backgroundSprites, (sprite: Phaser.Sprite, i: number) =>
    {
        //  reset sprite position

        sprite.reset((gameConfig.bgTileWidth - 1) * i, 0);

        switch (i)
        {
            case 0:

                sprite.loadTexture('bg-outside');
                sprite.frameName = 'outside-2';

                break;

            //case 1:
            //
            //    sprite.loadTexture('bg-outside');
            //    sprite.frameName = 'outside-2';
            //
            //    break;

            default:

                sprite.loadTexture(getTileSetName());
                sprite.frameName = getTileSetId() + '-' + (i % 4);

                break;
        }

    });

    outsideTile = null;
}


/**
 * update all current offscreen tiles to use the new tileset
 */
export function startUsingNewTileset()
{
    var offscreenOutsideSprites: Phaser.Sprite[],
        transitionSprite: Phaser.Sprite;

    //  find all sprites that are currently off-screen


    //  is the next stage inside or outside?
    //  if we're going back inside, let's make the first off-screen tile use the outdoors-indoors transition texture

    if ( ! gameState.level.isOutside)
    {
        //  add a transition tile to go outside to inside

        insideTile = transitionSprite = last(outsideSprites);

        transitionSprite.loadTexture('bg-outside', 2);

        //  find and hide all other off-screen sprites

        offscreenOutsideSprites = filter(without(outsideSprites, transitionSprite), (sprite: Phaser.Sprite) =>
        {
            //log.debug('checking:', sprite.x, game.world.width - levelGroup.x)

            return sprite.x > game.world.width - levelGroup.x;
        });

        //  get the remaining on-screen outside sprites

        var onscreenOutside: Phaser.Sprite[];

        onscreenOutside = without(difference(outsideSprites, offscreenOutsideSprites), transitionSprite);

        transitionSprite.x = last(onscreenOutside).x + gameConfig.bgTileWidth;

        //transitionSprite.x = game.world.width - levelGroup.x;

        forEach(offscreenOutsideSprites, (sprite: Phaser.Sprite) =>
        {
            sprite.y = 9999;
        });
    }


    //  reset the tile index count

    tileCount = 0;

    //  update their tileset and frame name

    forEach(backgroundSprites, (sprite: Phaser.Sprite, i: number) =>
    {
        //  load the new tile texture for all sprites

        sprite.loadTexture(getTileSetName(), 0);

        //  set the frame name for each

        sprite.frameName = getFrameName();

        //  increment the tile count

        incrementTileCount();

        sprite.x = transitionSprite.x + gameConfig.bgTileWidth * i;
    });

    offsetX = levelGroup.x * -1;


    offsetX = gameConfig.bgTileWidth * 1.5 - levelGroup.x;

    //pushUpOffscreenTiles();
}



/**
 * get the next tile that's still off-stage
 */
export function queueOutsideTiles()
{
    outsideSprites[0].frameName = 'outside-0';
    outsideSprites[1].frameName = 'outside-1';
    outsideSprites[2].frameName = 'outside-1';
    outsideSprites[3].frameName = 'outside-1';
    outsideSprites[4].frameName = 'outside-1';

    //  save reference to the first outside tile

    outsideTile = outsideSprites[0];

    var x: number;

    x = game.world.width - levelGroup.x;

    forEach(outsideSprites, (sprite: Phaser.Sprite) =>
    {
        sprite.x = x;
        sprite.y = 0;

        x += gameConfig.bgTileWidth - 3;
    });

    log.debug('outside tile X:', outsideTile.x);

    //outsideSprites = outsideSprites.reverse();

    offsetX = gameConfig.bgTileWidth * 1.5 - levelGroup.x;
    //offsetX = levelGroup.x * -1;
}


/**
 * check the position of the background tiles
 */
export function updateBackground()
{
    var sprite: Phaser.Sprite;


    if (gameState.level.isOutside)
    {
        checkOutsideSpritePosition();
    }

    //

    //  while we're outside, all tiles should loop the same outdoor texture

    if (gameState.level.isOutside)
    {
        //if (offsetX + levelGroup.x > - gameConfig.bgTileWidth) return;

        //checkOutsideSpritePosition();

        sprite = head(outsideSprites);

        if (sprite.x >= levelGroup.x * -1 - gameConfig.bgTileWidth) return;

        sprite.x = Math.floor(last(outsideSprites).x + gameConfig.bgTileWidth) - 3;
        sprite.frameName = 'outside-1';

        outsideSprites.push(outsideSprites.splice(0, 1)[0]);
    }

    if (insideTile && insideTile.x + levelGroup.x < 0)
    {
        //log.debug('RESTORING INSIDE', insideTile.x, game.world.width, levelGroup.x, game.world.width - levelGroup.x);

        insideTile = null;

        queuePowerUp();
        restartObstacles();

        //  reenable platforms

        allowPlatforms(true);
    }


    //  when the game has moved on far enough, move the first tile to the back of the queue



    sprite = head(backgroundSprites);


    if (sprite.x >= levelGroup.x * -1 - gameConfig.bgTileWidth) return;

    sprite.x = Math.floor(last(backgroundSprites).x + gameConfig.bgTileWidth) - 3;

    backgroundSprites.push(backgroundSprites.splice(0, 1)[0]);

    offsetX = levelGroup.x * -1;

    //  load the new tile texture for all sprites

    sprite.loadTexture(getTileSetName(), 0);

    //  set the frame name for each

    sprite.frameName = getFrameName();

    //  increment the tile count

    incrementTileCount();

}



/**
 * has the outside tile appeared on screen yet?
 */
function checkOutsideSpritePosition()
{
    //  check the position of the outside tile;
    //  if it's not on screen yet, stop here

    if (outsideTile) log.debug(outsideTile.x, ' -- ', game.world.width * 0.33 - levelGroup.x)

    if (! outsideTile || (outsideTile.x + levelGroup.x > game.world.width * 0.33)) return;

    //  when it appears on screen, let's bring the game to a standstill while we ask a question

    gameState.player.isControllable = false;

    //  move zingy to the middle of the screen


    showSign();

    //  make zingy hoist his sign



    //  show the question popup

    setTimeout(() => showSecondaryScreen('question'), 3500);

    //  clear the outside tile reference

    outsideTile = null;

    //  stop counting down time

    stopCountdownTimer();

    //  prevent the player from interacting

    // gameState.player.isControllable = false;

    //TODO  stop the score time progressing

    //TODO  stop the game time countdown while we roll into the outside area
}


// WEBPACK FOOTER //
// ./src/ts/game/level/backgrounds/Backgrounds.ts